module.exports = __webpack_public_path__ + "img/prepaid50-en.df2ee0d6.svg";